import { joinInfoMeta } from './joinMetaInfo.js';
import { mergeMetadata } from './mergeMetadata';
import { parseData } from './parseData';
import { setFIDSpectrumData } from './setFIDSpectrumData';
import { setXYSpectrumData } from './setXYSpectrumData';

export async function convert2D(files, options) {
  const result = mergeMetadata(
    await parseData(files.procs, options),
    await parseData(files.proc2s, options),
  );

  const acqus = mergeMetadata(
    await parseData(files.acqus, options),
    await parseData(files.acqu2s, options),
  );

  joinInfoMeta(result, acqus);

  result.meta.nbSubSpectra = files['2rr']
    ? parseInt(result.meta.SI[1], 10)
    : parseInt(result.meta.TD[1], 10);

  if (!result.meta.SW_p) {
    // eslint-disable-next-line camelcase
    result.meta.SW_p = result.meta.SW_h;
  }
  if (!result.meta.SF) {
    result.meta.SF = result.meta.SFO1;
  }

  let firstY, lastY, xOffset, yOffset;
  if (files['2rr']) {
    let sf = Number(result.meta.SF[1]);
    let swP = Number(result.meta.SW_p[1] || result.meta.SW[1]);
    yOffset = Number(result.meta.OFFSET[1]);
    xOffset = Number(result.meta.OFFSET[0]);
    firstY = yOffset;
    lastY = yOffset - swP / sf;
    result.meta.firstY = firstY;
    result.meta.lastY = lastY;
    await setXYSpectrumData({ re: files['2rr'] }, result, true);
  } else if (files.ser) {
    firstY = 0;
    lastY = result.meta.nbSubSpectra;
    let xWindowSize = Number(result.meta.SW[0]);
    let yWindowSize = Number(result.meta.SW[1]);
    let xTransmitterFrequency = Number(result.meta.SFO1[0]);
    let yTransmitterFrequency = Number(result.meta.SFO1[1]);
    let xTransmitterFrequencyOffset = Number(result.meta.O1[0]);
    let yTransmitterFrequencyOffset = Number(result.meta.O1[1]);
    xOffset =
      xTransmitterFrequencyOffset / xTransmitterFrequency + xWindowSize / 2;
    yOffset =
      yTransmitterFrequencyOffset / yTransmitterFrequency + yWindowSize / 2;
    await setFIDSpectrumData(files.ser, result);
  }

  let pageValue = firstY;
  let nbSubSpectra = result.meta.nbSubSpectra / (files['2rr'] ? 1 : 2);
  let deltaY = (lastY - firstY) / (nbSubSpectra - 1);
  for (let i = 0; i < nbSubSpectra; i++) {
    pageValue += deltaY;
    result.spectra[i].pageValue = pageValue;
  }
  let { NUC1: nuc1, AXNUC: axnuc, SF: sf } = result.meta;
  const nucleus = axnuc ? axnuc : nuc1 ? nuc1 : [];
  result.info['2D_Y_NUCLEUS'] = nucleus[1];
  result.info['2D_X_NUCLEUS'] = nucleus[0];
  result.info['2D_Y_FRECUENCY'] = sf[1];
  result.info['2D_X_FRECUENCY'] = sf[0];
  result.info['2D_Y_OFFSET'] = yOffset;
  result.info['2D_X_OFFSET'] = xOffset;
  result.info.twoD = result.twoD = true;

  return result;
}
